export default {
    state: {
        requestCount: 0,
    },
    mutations: {
        startLoading(state, timeout) {
            state.requestCount += 1;

            var store = this;
            setTimeout(function () {
                store.commit('stopLoading');
            }, timeout || 30000);
        },
        stopLoading(state) {
            state.requestCount = Math.max(state.requestCount - 1, 0);
        },
    },
};
